import React, { useState } from 'react';
import PropTypes from "prop-types";
import { Select, Tree ,Form} from "antd";
const { Option } = Select

const generateChildData = (id,projarray)=>{
  return projarray.filter(el=>el.hmg_id===id).map(prj=>({
    title: prj.project_name,
    key: prj._id,
  }))
}

const generateTreeData = (hmgarray, projarray)=>{
  return hmgarray.map(el=>{
    
    return {
      title: el.hmg_name,
      key: el._id,
    }
  })
}

const treeData = [
  {
    title: '0-0',
    key: '0-0',
    children: [
      {
        title: '0-0-0',
        key: '0-0-0',
        children: [
          {
            title: '0-0-0-0',
            key: '0-0-0-0',
          },
          {
            title: '0-0-0-1',
            key: '0-0-0-1',
          },
          {
            title: '0-0-0-2',
            key: '0-0-0-2',
          },
        ],
      },
      {
        title: '0-0-1',
        key: '0-0-1',
        children: [
          {
            title: '0-0-1-0',
            key: '0-0-1-0',
          },
          {
            title: '0-0-1-1',
            key: '0-0-1-1',
          },
          {
            title: '0-0-1-2',
            key: '0-0-1-2',
          },
        ],
      },
      {
        title: '0-0-2',
        key: '0-0-2',
      },
    ],
  },
  {
    title: '0-1',
    key: '0-1',
    children: [
      {
        title: '0-1-0-0',
        key: '0-1-0-0',
      },
      {
        title: '0-1-0-1',
        key: '0-1-0-1',
      },
      {
        title: '0-1-0-2',
        key: '0-1-0-2',
      },
    ],
  },
  {
    title: '0-2',
    key: '0-2',
  },
];

const HMGMapping=(props)=> {
  const {
    checkMainRoleValue,
    getFieldValue,
    corporateUsersHmgOnChange,
    initialValue,
    hmgMainGetData,
    hmgGetData,
  } = props;

  const hmgMainGetOptions = hmgMainGetData.map((d) => (
    <Option key={d._id}>{d.hmg_name}</Option>
  ));

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);

  const onExpand = (expandedKeysValue) => {
    console.log('onExpand', expandedKeysValue); // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.

    setExpandedKeys(expandedKeysValue);
    setAutoExpandParent(false);
  };

  const onCheck = (checkedKeysValue) => {
    console.log('onCheck', checkedKeysValue);
    setCheckedKeys(checkedKeysValue);
  };

  const onSelect = (selectedKeysValue, info) => {
    console.log('onSelect', info);
    setSelectedKeys(selectedKeysValue);
  };

  return (
    <div>
      <div
        style={
          checkMainRoleValue(getFieldValue("main_role")) ||
          (getFieldValue("myp_user") &&
            process.env.REACT_APP_PLATFORM_TYPE &&
            process.env.REACT_APP_PLATFORM_TYPE === "GENERIC")
            ? { display: "block" }
            : { display: "none" }
        }
      >
        <Form.Item label="HMG" name="corporate_user_hmg">
         
            <Select
              onChange={(e) => {
                corporateUsersHmgOnChange(
                  e,
                  checkMainRoleValue(getFieldValue("main_role"))
                );
              }}
              placeholder="Enter HMG"
              showSearch
              optionFilterProp="children"
              notFoundContent={null}
              allowClear={true}
              disabled={initialValue && initialValue.myp_id}
            >
              {hmgMainGetOptions}
            </Select>
      
        </Form.Item>
      </div>
      <div>
      <Tree
      checkable
      onExpand={onExpand}
      expandedKeys={expandedKeys}
      autoExpandParent={autoExpandParent}
      onCheck={onCheck}
      checkedKeys={checkedKeys}
      onSelect={onSelect}
      selectedKeys={selectedKeys}
      treeData={generateTreeData(hmgMainGetData,hmgGetData)}
    />
      </div>
    </div>
  );
}

HMGMapping.propTypes = {};

export default HMGMapping;
